import {
  Tooltip as ShadCnTooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "@components/ui/tooltip";
import React from "react";

type Props = {
  children: string | React.ReactNode;
  description: string | React.ReactNode;
};

const Tooltip: React.FC<Props> = ({ children, description }) => {
  return (
    <>
      <TooltipProvider>
        <ShadCnTooltip>
          <TooltipTrigger asChild className="cursor-pointer w-fit">
            {children}
          </TooltipTrigger>
          <TooltipContent>
            <p
              className="flex items-center max-h-[200px] overflow-y-auto"
              dangerouslySetInnerHTML={{ __html: `<div>${description}</div>` }}
            ></p>
          </TooltipContent>
        </ShadCnTooltip>
      </TooltipProvider>
    </>
  );
};

export default Tooltip;
